<ng-container *transloco="let t; prefix: 'my-profile.selling.selling-details.overview.upload-photos'">
    <div class="container flex flex-col gap-5 my-[100px]">
      <div class="flex flex-col text-left">
        <h1 class="h2 text-black">{{ t('photos') }}</h1>
      </div>
  
      <div class="flex flex-col bg-white rounded-lg border border-gray-200 justify-between p-5 gap-8">
        <div class="flex flex-col-reverse xl:flex-row justify-between">
          <div class="flex flex-col gap-8">
            <h2 class="text-xl text-black font-bold">{{ t('makeYourPropertyStandOut') }}</h2>
            <div class="grid grid-cols-2 grid-rows-2 gap-6 max-w-[570px]">
              <div class="flex flex-row gap-2">
                <i class="icon-check text-primary-700"></i>
                <span class="text-sm">{{ t('highResolutionPhotos') }}</span>
              </div>
              <div class="flex flex-row gap-2">
                <i class="icon-check text-primary-700 pt-1"></i>
                <span class="text-sm">{{ t('interactiveVirtualTour') }}</span>
              </div>
              <div class="flex flex-row gap-2">
                <i class="icon-check text-primary-700"></i>
                <span class="text-sm">{{ t('accurateFloorPlans') }}</span>
              </div>
              <div></div>
            </div>
          </div>
          <div class="flex flex-col rounded-lg gap-1 p-2 px-3 images">
            <div class="flex flex-row gap-1 image-row">
              <img style="border-top-left-radius: 10px;" alt="" class="image" src="../../../../../../../assets/img/image-grid-1.png">
              <img style="border-top-right-radius: 10px;" alt="" class="image" src="../../../../../../../assets/img/image-grid-2.png">
            </div>
            <div class="flex flex-row gap-1 image-row">
              <img style="border-bottom-left-radius: 10px;" alt="" class="image" src="../../../../../../../assets/img/image-grid-3.png">
              <img style="border-bottom-right-radius: 10px;" alt="" class="image" src="../../../../../../../assets/img/image-grid-4.png">
            </div>
          </div>
        </div>
        <div class="flex flex-col-reverse md:flex-row justify-between gap-2">
          <button [localizedRouterLink]="['/services/photography']" class="btn-primary" type="button">{{ t('learnMore') }}</button>
          <div class="bg-primary-50 rounded-lg flex flex-row p-4 items-center gap-2">
            <span class="text-primary-800 text-lg">95%</span>
            <span class="text-wrap text-xs">{{ t('buyersInterest') }}</span>
            <div class="flex items-center justify-center rounded-full w-10 h-10">
              <img src="../../../../../../../assets/img/Smily face.svg" />
            </div>
          </div>
        </div>
      </div>
  
      <div class="flex flex-col gap-3">
        <h2 class="text-black font-bold text-2xl">
          {{ t('mainPhoto') }}
        </h2>
        <p>
          {{ t('mainPhotoDescription') }}
        </p>
        <div class="flex flex-col md:flex-row bg-cyan-50 rounded-lg border border-cyan-400 justify-between p-5 gap-5">
          <div class="text-black">
            <i class="icon-lightbulb-02 mr-2"></i>
            <span>{{ t('mainPhotoTip') }}</span>
          </div>
        </div>
        <div (dragleave)="coverDragover = false;"
             (dragover)="onDragOver($event); coverDragover = true;" (drop)="onCoverDropSuccess($event)"
             [ngClass]="coverDragover ? 'bg-gray-100': ''"
             class="flex flex-col border-dashed rounded-lg border border-gray-600 justify-between p-5 gap-5">
          <div class="flex flex-row justify-between">
            <div class="flex flex-col md:flex-row md:items-center gap-2">
              <span class="text-black">{{ t('dragImageHere') }} <span>{{ t('or') }}</span></span>
              <label class="btn-text text-primary-600 text-left text-underline hover:cursor-pointer"
                     for="cover-photo-upload">{{ t('chooseFromDevice') }}</label>
              <input #coverPhotoUpload (change)="onCoverPhotoSelected($event)" (click)="coverPhotoUpload.value = '';" id="cover-photo-upload"
                     type="file" accept="image/jpeg, image/jpg">
            </div>
            <div class="bg-white border border-gray-200 flex items-center justify-center rounded-full w-14 h-14">
              <i class="icon-camera text-primary-700"></i>
            </div>
          </div>
          <div class="flex flex-wrap gap-2 text-xs">
            <span>{{ t('landscapeOnly') }}</span>
            <span>{{ t('acceptedFormats') }}</span>
            <span>{{ t('minWidth') }}</span>
            <span>{{ t('maxSize') }}</span>
          </div>
        </div>
        <div *ngIf="coverPhoto && coverPhoto.previewSrc" class="flex flex-col w-[340px]">
          <div class="w-full h-[230px]">
            <picture>
              <source [srcset]="coverPhoto.previewSrc" type="image/webp">
              <source [srcset]="coverPhoto.fallbackSrc" type="image/jpeg">
              <img [src]="coverPhoto.fallbackSrc"
                   alt="cover-photo" class="rounded-t-lg w-full h-full object-center object-cover pointer-events-none img-disable-context">
            </picture>
          </div>
          <div class="flex items-start justify-between bg-white rounded-b-lg p-2.5">
            <div class="flex items-start justify-between">
              <button (click)="onTagAdd(coverPhoto, false)" *ngIf="!coverPhoto.tag"
                      class="btn-text text-primary-700 text-left">
                <i class="icon-plus mr-2"></i>{{ t('buttons.addTags') }}
              </button>
              <div (click)="onTagAdd(coverPhoto, false)" *ngIf="coverPhoto.tag"
                   class="bg-gray-50 px-1.5 py-1 text-gray-800 hover:bg-primary-50 hover:text-primary-700 rounded-sm hover:cursor-pointer">
                {{ 'shared.enum.mediaTag.' + coverPhoto.tag | transloco }} <i class="icon-edit ml-2 text-xs"></i></div>
            </div>
            <div class="">
              <button (click)="onDeletePhoto(coverPhoto)" type="button">
                <i class="icon-trash"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
  
      <div class="flex flex-col gap-3">
        <h2 class="text-black font-bold text-2xl">
          {{ t('otherPhotos') }}
        </h2>
        <p>
          {{ t('otherPhotosDescription') }}
        </p>
        <div class="flex flex-col border-dashed rounded-lg border border-gray-600 justify-between p-5 gap-5">
          <div class="flex flex-row justify-between">
            <div class="flex flex-col md:flex-row items-center gap-2">
              <span class="text-black">{{ t('dragImageHere') }} <span>{{ t('or') }}</span></span>
              <label class="btn-text text-primary-600 text-left text-underline hover:cursor-pointer"
                     for="secondary-photos-upload">{{ t('chooseFromDevice') }}</label>
              <input #secondaryPhotosUpload (change)="onSecondaryPhotosSelected($event)" accept="image/jpeg, image/jpg"
                     [multiple]="true" id="secondary-photos-upload" (click)="secondaryPhotosUpload.value = '';"
                     type="file">
            </div>
            <div class="bg-white border border-gray-200 flex items-center justify-center rounded-full w-14 h-14">
              <i class="icon-camera text-primary-700"></i>
            </div>
          </div>
          <div class="flex flex-wrap gap-2 text-xs">
            <span>{{ t('landscapeOnly') }}</span>
            <span>{{ t('acceptedFormats') }}</span>
            <span>{{ t('minWidth') }}</span>
            <span>{{ t('maxSize') }}</span>
          </div>
        </div>
        <div [cdkDropListData]="secondaryPhotos" [cdkDropListOrientation]="'horizontal'" cdkDropList
             class="flex flex-wrap gap-4 md:gap-14">
          <div *ngFor="let secondaryPhoto of secondaryPhotos;" [cdkDragData]="secondaryPhoto" cdkDrag
               class="flex flex-col">
            <div *ngIf="secondaryPhoto && secondaryPhoto.previewSrc"
              class="w-[170px] h-[116px] md:w-[210px] md:h-[142px] hover:scale-125 transition duration-500 cursor-pointer">
              <picture>
                <source [srcset]="secondaryPhoto.previewSrc" type="image/webp">
                <source [srcset]="secondaryPhoto.fallbackSrc" type="image/jpeg">
                <img
                  [src]="secondaryPhoto.fallbackSrc"
                  alt="secondary-photo" class="rounded-medium w-full h-full object-center object-cover pointer-events-none img-disable-context">
              </picture>
            </div>
            <div class="flex items-start justify-between bg-white rounded-b-lg p-2.5">
              <div class="flex items-start justify-between">
                <button (click)="onTagAdd(secondaryPhoto, true)" *ngIf="!secondaryPhoto.tag"
                        class="btn-text text-primary-700 text-left">
                  <i class="icon-plus mr-2"></i>{{ t('buttons.addTags') }}
                </button>
                <div (click)="onTagAdd(secondaryPhoto, true)"
                     *ngIf="secondaryPhoto.tag"
                     class="bg-gray-50 px-1.5 py-1 text-gray-800 hover:bg-primary-50 hover:text-primary-700 rounded-sm hover:cursor-pointer">
                  {{ 'shared.enum.mediaTag.' + secondaryPhoto.tag | transloco }} <i class="icon-edit ml-2 text-xs"></i></div>
              </div>
              <div class="">
                <button (click)="onDeletePhoto(secondaryPhoto)" type="button">
                  <i class="icon-trash"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>